"use client";
import * as n from "react";
import c from "react-dom";
const s = (param)=>{
    let { children: r, className: e } = param;
    const [t, i] = n.useState(null);
    return n.useEffect(()=>{
        if (!t) {
            const o = document.createElement("div");
            o.style.isolation = "isolate", i(o), document.body.appendChild(o);
        }
        return ()=>{
            t && document.body.removeChild(t);
        };
    }, [
        t
    ]), n.useEffect(()=>(t && e && t.classList.add(...e.split(" ")), ()=>{
            t && e && t.classList.remove(...e.split(" "));
        }), [
        e,
        t
    ]), t && /*#__PURE__*/ c.createPortal(r, t);
};
export { s as Portal };
